module.exports = __webpack_public_path__ + "assets/img/Inter-Light.svg?c74c81db857ef6cc37a7e4a0e7a92e3e";